import { render, staticRenderFns } from "./CreatorsByTalentRepList.vue?vue&type=template&id=27ab409e&"
import script from "./CreatorsByTalentRepList.vue?vue&type=script&lang=ts&"
export * from "./CreatorsByTalentRepList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports